<div fxLayout="column" ngClass.desktop="pl-56 pr-56 pt-48 pb-48 shadow-content" ngClass.mobile="pt-24 pl-16 pr-16 w-100 mt-40"
     fxFlexAlign="center">
    <div class="text-center">
        <div class="h2-semi-bold">
            {{ phone | mask: '0 (000) 000-00-00': {prefix: '+'} }}
        </div>
        <div class="t2 mt-8">{{ 'i18n_auth_codeSubtitle' | translate }}</div>
    </div>
    @if (oauthHolderService.hasEresidencyScope) {
        <ui-kit-error-panel class="mt-16" color="red" errorWarningPanelTitle="i18n_auth_codeRoamingWarning"/>
    }
    <ui-kit-code-input #codeInput
                       fxFlexAlign="center"
                       class="mt-32 mb-8"
                       [class.error]="confirmationStatus"
                       [disabled]="Spinner.isShown('code') || disableCodeInput"
                       [isCodeHidden]="false"
                       [isCharsCode]="false"
                       [codeLength]="codeLength"
                       [initialFocusField]="0"
                       [isFocusingOnLastByClickIfFilled]="true"
                       [isPrevFocusableAfterClearing]="true"
                       (codeCompleted)="onCodeComplete($event)"
                       (codeChanged)="onCodeChanged()">
    </ui-kit-code-input>
    @if (confirmationStatus) {
        <div fxFlexAlign="center" class="code-input-width pl-16">
            <div class="t2 c-secondary-red-800">{{ 'i18n_auth_codeError#' + confirmationStatus | translate }}</div>
        </div>
    }
    @if (!isTimerExpired && !confirmationStatus && !Spinner.isShown('code')) {
        <div fxLayoutAlign="center center"
             [fxLayout]="localizationService.currentLanguage.locale === 'kk' ? 'row-reverse' : 'row'"
             class="mt-24">
            <span class="t2 c-primary-gray-600">{{ 'i18n_auth_codeResendTimer' | translate }}</span>
            <ui-kit-timer [timerStartTime]="smsCodeTimerStartTime"
                          [totalDurationSec]="expirationTimeout"
                          (timerExpired)="onTimerExpired()"
                          [ngClass]="{
                        'ml-4': localizationService.currentLanguage.locale !== 'kk',
                        'mr-4': localizationService.currentLanguage.locale === 'kk',
                      }"
                          class="t2 ml-4 c-primary-green-600"></ui-kit-timer>
        </div>
    }
    @if (isTimerExpired && !Spinner.isShown('code')) {
        <div fxFlexAlign="center"
             class="t2-semi-bold c-primary-green-800 mt-24 pointer"
             (click)="sendCode(true)">
            {{ 'i18n_auth_buttonResendCode' | translate }}
        </div>
    }
    <ui-kit-spinner spinnerIds="code" fxFlexAlign="center" class="mt-24"></ui-kit-spinner>
</div>
